import { css } from '@emotion/react'
import mediaQueries from './media-queries'

export const containerStyles = css`
  display: flex;
  flex-wrap: wrap;
`

export const mainStyles = (showSidebarMenu) => (theme) =>
  css`
    flex: 1;
    padding: 30px 0px 0px;
    background-color: ${theme.colors.white};
    margin-left: 0;
    height: initial;
    min-height: 100vh;
    width: calc(100% - 300px);

    ${mediaQueries.smallScreen(-88)} {
      padding: 30px 0 0;
    }

    ${mediaQueries.smallScreen(-280)} {
      ${showSidebarMenu && `margin-left: 300px;`}
    }
  `

export const mainEmbeddedStyles = css`
  ${mediaQueries.smallScreen(-280)} {
    margin-left: 0;
  }
`

export const contentStyles = (theme) => css`
  max-width: ${theme.maxWidth};
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 0 16px 60px;

  ${mediaQueries.smallScreen(-88)} {
    padding: 0 32px 60px;
  }

  ${mediaQueries.mediumScreen()} {
    padding: 0 32px 60px;
  }

  ${mediaQueries.largeScreen()} {
    max-width: ${theme.maxWidth};
  }
`
